import { useCallback, useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectToken } from "../../features/auth/authSlice";
import classes from "./Bcs.module.css";
import { Button, Stack, Typography } from "@mui/material";
import { BasicCard } from "./BasicCard";
import {
  addGroup,
  selectActiveDaoTrangId,
  selectGroups,
  selectMembers,
  setGroupChecked,
  updateActiveDaoTrang,
} from "../../features/daoTrang/daoTrangSlice";
import {
  getAllGroups,
  createGroup,
  saveOrCreateGroup,
  newDefaultGroup,
} from "../../services/group/groupApi";
import { BigSpin } from "../DaoTrang/BigSpin";
import { Content } from "../Content/Content";
import {
  groupFromMongo,
} from "../../utils/mongoUtil";
import { exportAllToXlsx } from "../../utils/export";
import { MyContainer } from "../Layout/MyContainer";

const BCS = ({ navigate, params = {} }) => {
  let { id: daoTrangId } = params;

  const [loadingState, setLoadingState] = useState("idle");
  const dispatch = useAppDispatch();

  const token = useAppSelector(selectToken);
  const activeDaoTrangId = useAppSelector(selectActiveDaoTrangId);
  const members = useAppSelector(selectMembers);
  const groups = useAppSelector(selectGroups);

  // if navigate form memnu: daoTrangId = activeDaoTrang
  if (!daoTrangId) {
    daoTrangId = activeDaoTrangId;
  }
    async function loader(id) {
      setLoadingState("loading");

      const { result: groups, error } = await getAllGroups(id, token);
      if (error) {
        console.log(error);
      } else {
        // console.log(groups);
        // validate groups;
        const changedLst = validateGroups(members, groups, true);

        // // save to db
        // for await (const g of changedLst) {
        //   var res = await saveGroup(g);
        //   if (res.error) {
        //     console.log(res.error);
        //   }
        // }

        // // save
        dispatch(updateActiveDaoTrang({ groups: changedLst }));
      }

      setLoadingState("idle");
    }
  useEffect(() => {
    // if navigate form memnu: daoTrangId = activeDaoTrang
    if (!daoTrangId) {
      navigate(-1);
      return;
    }



    if (!groups) {
      console.log("load groups");
      loader(daoTrangId);
    }
  }, [daoTrangId, dispatch, groups, members, navigate, token]);

  const onCheck = useCallback(
    (id, checked) => {
      console.log(id, checked);
      dispatch(setGroupChecked({ id, checked }));
    },
    [dispatch]
  );

  const onSave = async () => {
    console.log("onsave")
    try {
      // var g=JSON.parse( localStorage.getItem("groups"))
      await Promise.all( groups.map(async (g) => {
        var { error } = await saveOrCreateGroup(g);
        if (error) {
          console.log(error);
        }
      }));
    } catch (ex) {
      console.log(ex.message);
    }
  }

  const onFileInput = useCallback(
    async (e) => {
      try {
        console.log("onFileInput");
        if (e.target.files.length === 0) {
          return;
        }

        setLoadingState("loading");

        const file = e.target.files[0];
        const text = await file.text();
        const raw = JSON.parse(text);
        const lst = [];
        raw.forEach((g) => {
          if (g.daoTrang) {
            lst.push(groupFromMongo(g));
          }
        });

        dispatch(updateActiveDaoTrang({ groups: lst }));
      } catch (ex) {
        console.log(ex.message);
      } finally {
        setLoadingState("idle");
      }
    },
    [dispatch]
  );

  // console.log(groups);
  async function onAdd() {
    var { result } = await createGroup(newGroup(daoTrangId), token); // create empty
    if (result) {
      dispatch(addGroup({ group: result }));
      navigate("GroupAdd", { groupsId: [result.id] });
    }
  }
  function onExport() {
    exportAllToXlsx({ groups, users: members }, true);
  }
  const footer = (
    <div className={classes.footer}>
      <Stack spacing={2} direction="row">
        <Button variant="contained" onClick={onSave}>
          Save
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            navigate("BcsEdit", { groupsId: getSlectedGroupId(groups) });
          }}
        >
          Edit
        </Button>
      </Stack>
    </div>
  );
  const inputRef = useRef(null);
  const title = (
    <Stack spacing={2} direction="row">
      <Typography variant={"h5"}>BCS</Typography>
      <input ref={inputRef} type="file" onInput={onFileInput} hidden={true} />
      <Button
        variant="contained"
        onClick={() => {
          inputRef.current?.click();
        }}
      >
        Import
      </Button>
      <Button variant="contained" onClick={onAdd}>
        Add
      </Button>
      <Button variant="contained" onClick={onExport}>
        Export
      </Button>
      <Button variant="contained" onClick={()=>loader(daoTrangId)}>
        Refresh
      </Button>
    </Stack>
  );

  function sortAndValidGroup(groups) {
    // validate groups;
    const changedLst = validateGroups(members, groups);
    return changedLst.sort((a, b) => a.name.localeCompare(b.name));
  }
  const renderData = groups ? sortAndValidGroup(groups) : [];
  // console.log(renderData);
  return (
    <Content title={title} footer={footer}>
      {loadingState === "loading" ? (
        <MyContainer>
          <BigSpin />
        </MyContainer>
      ) : (
        <MyContainer>
          {renderData.map((group, i) => (
            <BasicCard
              group={group}
              index={i}
              key={i}
              onCheck={(_index, check) => onCheck(group.id, check)}
              navigate={navigate}
            />
          ))}
        </MyContainer>
      )}
    </Content>
  );
};

export default BCS;
function getSlectedGroupId(groups) {
  return groups ? groups.filter((g) => g.checked).map((g) => g.id) : [];
}

/**
 *
 * @param {*} members
 * @param {*} groups
 * @returns [] list of modified group
 */
export function validateGroups(members, groups, merge = false) {
  const map = new Map();
  members.forEach((u) => map.set(u.email, u));

  var lst = groups.map((group) => {
    var { subGroups, ...clone } = group;
    clone.subGroups = subGroups.map(({ name, members }) => ({
      name,
      members: members.filter((email) => map.has(email)),
    }));
    return clone;
  });
  return lst;
}

export function newGroup(daoTrangId) {
  var obj = newDefaultGroup();
  obj.daoTrang = daoTrangId;
  return obj;
}
export function isValidGroup(g) {
  return ["members", "subLeader", "beginner"].every((sub) =>
    Array.isArray(g[sub])
  );
}
